import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "../app/auth.guard";
import { LoginComponent } from "../app/login/login.component";
import { RegisterComponent } from "../app/register/register.component";
import { AddUserComponent } from "../app/add-user/add-user.component";
import { ScheduleComponent } from "../app/schedule/schedule.component";
import { AuditLogsComponent } from "../app/audit-logs/audit-logs.component";
import { InfrastructureComponent } from "../app/infrastructure/infrastructure.component";
import { ActivityCatalogueComponent } from "../app/activity-catalogue/activity-catalogue.component";
import { ValidateComponent } from "../app/validate/validate.component";
import { ProfileComponent } from "../app/profile/profile.component";
import { EnterpriseManagementComponent } from "../app/enterprise-management/enterprise-management.component";
import { AdminVerificationComponent } from "../app/admin-verification/admin-verification.component";
import { NotificationComponent } from "../app/notification/notification.component";
import { ForgotpasswordComponent } from "./forgotpassword/forgotpassword.component";
import { PaymentConfirmationComponent } from "./payment-confirmation/payment-confirmation.component";

const routes: Routes = [
  { path: "", component: LoginComponent },
  { path: "registration", component: RegisterComponent },
  { path: "forgotpassword", component: ForgotpasswordComponent },
  { path: "forgotpassword/:token", component: ForgotpasswordComponent },
  { path: "adminverify/:token", component: AdminVerificationComponent },
  {
    path: "validate/:token",
    component: ValidateComponent,
  },
  { path: "user-list", component: AddUserComponent, canActivate: [AuthGuard] },
  { path: "schedule", component: ScheduleComponent, canActivate: [AuthGuard] },
  {
    path: "activity-catalogue",
    component: ActivityCatalogueComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "infrastructure",
    component: InfrastructureComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "audit-logs",
    component: AuditLogsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "profile",
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "enterprise-management/:token",
    component: EnterpriseManagementComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "payment-confirmation/:token/:redirect",
    component: PaymentConfirmationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "enterprise-management",
    component: EnterpriseManagementComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "notification",
    component: NotificationComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
